import React from "react";
import {tagService} from "../jwt/_services/clasificator/tagService";

export const tagProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await tagService.getAll();

        return listItems.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code + '-' + item.name,
                    label: <label>{ item.code.toUpperCase() + ' - '  } <b>{ item.name }</b> </label>
                }
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await tagService.getItem(id);
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}